// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"282":"24b667c6","919":"24b667c6"}[chunkId] + ".chunk.css";
};